export default __webpack_public_path__ + "./images/cf.c0b8bd0d.png";